import Locale from 'rmc-calendar/lib/locale/zh_CN';
export default Locale;



// WEBPACK FOOTER //
// ./components/calendar/locale/zh_CN.tsx